import { Api } from '@/interface/api';

/**
 * 获取当前登录用户的信息
 * @param accountId
 */
const getUserPersonalData: Api = {
    url: '/api/project/proxy/api/users/personalData',
    method: 'get',
};

export { getUserPersonalData };
